export default __webpack_public_path__ + "static/media/IFSC.95957af5.svg";